import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Obrigatorio } from 'src/app/decorators';
import { IToken } from 'src/app/interfaces/token/IToken';
import { AuthenticationService } from 'src/app/services';
import { SuprimentosService } from 'src/app/services/suprimentos/suprimentos.service';
import { ModalGeneralComponent } from '../modal-general/modal-general.component';
import { ListaPaginada } from 'src/app/models';
import { IEquipamentoSuprimento } from 'src/app/interfaces';

@Component({
  selector: 'app-listagem-equipamentos-suprimentos',
  templateUrl: './listagem-equipamentos-suprimentos.component.html',
  styleUrls: ['./listagem-equipamentos-suprimentos.component.scss']
})
export class ListagemEquipamentosSuprimentosComponent
  implements OnInit, OnDestroy
{
  @ViewChild(ModalGeneralComponent) modal: ModalGeneralComponent;
  @Input()
  @Obrigatorio()
  codContrato: string;
  @Input()
  @Obrigatorio()
  codProduto: string;
  subscriptions$ = new Subscription();
  equipamentosSuprimento = new ListaPaginada<IEquipamentoSuprimento>();
  public get nomesEquipamentos(): string {
    return this.equipamentosSuprimento.registros.reduce(
      (prev, el) => `${prev && prev + ', '}${el.nomeProduto}`,
      ''
    );
  }
  token: IToken;
  colunasVisiveis: string[] = ['codProduto', 'nomeProduto'];

  constructor(
    private suprimentosService: SuprimentosService,
    private authenticationService: AuthenticationService
  ) {}

  getEquipamentos() {
    this.subscriptions$.add(
      this.suprimentosService
        .getEquipamentosSuprimento({
          idUsuario: this.token.id,
          codContrato: this.codContrato,
          codProduto: this.codProduto,
          paginar: false
        })
        .subscribe({
          next: ({ data }) => {
            this.equipamentosSuprimento = data;
          }
        })
    );
  }

  abrirModal() {
    this.modal.openModal();
  }
  fecharModal() {
    this.modal.closeModalWithoutReload();
  }
  ngOnInit(): void {
    this.token = this.authenticationService.obterToken();
    this.getEquipamentos();
  }
  ngOnDestroy(): void {
    this.fecharModal();
    this.subscriptions$.unsubscribe();
  }
}
